var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.60326 1.81698C8.97008 1.07374 10.0299 1.07374 10.3967 1.81699L11.9124 4.88798C12.058 5.18313 12.3396 5.38769 12.6653 5.43502L16.0543 5.92748C16.8746 6.04667 17.2021 7.05464 16.6086 7.63317L14.1562 10.0236C13.9205 10.2533 13.813 10.5843 13.8686 10.9087L14.4475 14.2841C14.5877 15.101 13.7302 15.724 12.9966 15.3383L9.96534 13.7446C9.67402 13.5915 9.32598 13.5915 9.03466 13.7446L6.0034 15.3383C5.26978 15.724 4.41235 15.101 4.55246 14.2841L5.13137 10.9087C5.18701 10.5843 5.07946 10.2533 4.84378 10.0236L2.39144 7.63317C1.79792 7.05464 2.12543 6.04667 2.94565 5.92748L6.3347 5.43502C6.66041 5.38769 6.94197 5.18313 7.08764 4.88798L8.60326 1.81698Z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.744eba6d8edcf11bc78e060aa7770025.svg";
export { ForwardRef as ReactComponent };